import React from 'react';
import PropTypes from 'prop-types';

import defPic from 'assets/img/icons/default_pic.jpg';
import _app from '../../../server';

import { tours_setDefaultPic } from 'redux/actions/tours';

import BootstrapTable from 'react-bootstrap-table-next';
import { CircularProgressbar } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import 'assets/css/customs.css';

const moment = require('moment');
const LiveTable = ({
    xs,
    sm,
    md,
    lg,
    xl,
    onDoubleClicked,
    actives,
    dispatch,
    auth
}) => {
    const { byid, list } = actives;

    let imgFormatter = (cell, row) => {
        let avatars = cell.map(link => {
            return (
                <div className='table-img-cont' key={link}>
                    <img
                        onError={() => {
                            dispatch(tours_setDefaultPic(row.trackerId));
                        }}
                        src={link}
                        height='100%'
                        alt=''
                    />
                </div>
            )
        })
        return (
            <div>
                {avatars}
            </div>
        );
    };
    let _toPercentage = prog => {
        let nume = prog.split('/')[0];
        let denum = prog.split('/')[1];
        return (nume / denum) * 100;
    };
    let progFormatter = cell => {
        return (
            <div className='table-img-cont'>
                <CircularProgressbar
                    value={_toPercentage(cell)}
                    text={cell}
                    styles={{
                        text: {
                            fill: '#ea5a5a'
                        },
                        path: {
                            stroke: '#ea5a5a'
                        }
                    }}
                    strokeWidth='12'
                />
            </div>
        );
    };

    let columns = [
        {
            dataField: 'tracker_id',
            text: 'Tracker ID',
            hidden: true,
            sort: true
        },
        {
            dataField: 'link',
            text: ' ',
            headerClasses: 'table-col-head',
            headerStyle: { width: '90px' },
            formatter: imgFormatter,
            sort: false
        },
        {
            dataField: 'name',
            text: 'Name',
            headerClasses: 'table-col-head text-md-left',
            sort: true
        },
        {
            dataField: 'staff_id',
            text: 'Staff No',
            hidden: lg,
            headerClasses: 'table-col-head',
            headerStyle: { width: '100px' },
            sort: true
        },
        {
            dataField: 'device',
            text: 'Device',
            hidden: md,
            headerClasses: 'table-col-head',
            sort: true
        },
        {
            dataField: 'phone',
            text: 'Phone Number',
            hidden: xl,
            headerClasses: 'table-col-head',
            sort: true
        },
        {
            dataField: 'zone',
            text: 'Zone',
            hidden: xs,
            headerClasses: 'table-col-head'
        },
        {
            dataField: 'progress',
            text: 'Progress',
            hidden: sm,
            headerClasses: 'table-col-head',
            formatter: progFormatter,
            sort: false
        },
        {
            dataField: 'start',
            text: 'Started On',
            headerClasses: 'table-col-head',
            headerStyle: { whiteSpace: 'wrap', width: '100px' },
            sort: true
        }
    ];

    let data = [];
    list.forEach(tid => {
        let active = byid[tid];
        if (active.isTour) {
            const { patrollers } = active.session;

            let links = [];
            let names;
            let staffIds;
            let phones;

            if (patrollers) {
                patrollers.forEach(p => {
                    let link = defPic;
                    if (!p.useDefault) {
                        if (p.container !== null && p.filename !== null) {
                            link = `${_app.api}Storages/${p.container}/download/${p.filename}?access_token=${auth}`;
                        } else {
                            link = p.link;
                        }
                    }
                    links.push(link);
                })
                names = patrollers.map(p => {
                    return (
                        <p key={p.name} className='table-text-cont'>
                            {p.name}
                        </p>
                    )
                });
                staffIds = patrollers.map(p => {
                    return (
                        <p key={p.staffId} className='table-text-cont'>
                            {p.staffId}
                        </p>
                    )
                });
                phones = patrollers.map(p => {
                    return (
                        <p key={p.phoneNumber} className='table-text-cont'>
                            {p.phoneNumber}
                        </p>
                    )
                });
            }

            let row = {
                tracker_id: tid,
                name: <div> {names} </div>,
                staff_id: <div> {staffIds} </div>,
                device: active.session.callerId,
                phone: <div> {phones} </div>,
                zone: active.tour.section,
                progress: `${active.tour.visited.list.length}/${active.tour.count}`,
                start: moment(active.tour.startTimestamp).format(
                    'YYYY/MM/DD h:mm:ss A'
                ),
                link: links
            };
            data.push(row);
        }
    });

    const rowEvents = {
        onDoubleClick: (e, row) => {
            onDoubleClicked(row);
        }
    };

    return (
        <BootstrapTable
            bootstrap4
            classes='table-md table-responsive-sm text-center align-middle'
            keyField='staff_id'
            data={data}
            columns={columns}
            striped
            hover
            condensed
            bordered={false}
            noDataIndication='No active session available'
            rowEvents={rowEvents}
        />
    );
};

LiveTable.propTypes = {
    xs: PropTypes.bool,
    sm: PropTypes.bool,
    md: PropTypes.bool,
    lg: PropTypes.bool,
    xl: PropTypes.bool,
    onDoubleClicked: PropTypes.func,
    actives: PropTypes.object,
    dispatch: PropTypes.func,
    auth: PropTypes.string
};

export default LiveTable;



// WEBPACK FOOTER //
// ./src/components/blocks/LiveTable/LiveTable.js